import { Component, inject } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { ZendeskButtonComponent } from '../zendesk-button/zendesk-button.component';
import { ZendeskOrigin } from '@app/shared/models/zendesk.model';
import { PreLoaderService } from '@app/shared/services/pre-loader.service';
import { ButtonComponent } from '@shared/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'slotcom-pre-loader',
  templateUrl: './pre-loader.component.html',
  styleUrls: ['./pre-loader.component.scss'],
  standalone: true,
  imports: [LoadingComponent, ZendeskButtonComponent, ButtonComponent, TranslateModule, UpperCasePipe],
})
export class PreLoaderComponent {
  readonly ZendeskOrigin = ZendeskOrigin;

  private readonly _preLoaderService = inject(PreLoaderService);

  readonly hasError = this._preLoaderService.hasError;
  readonly retriesExhausted = this._preLoaderService.retriesExhausted;

  retry(): void {
    this._preLoaderService.init();
  }

  reload(): void {
    window.location.reload();
  }
}
